import {useContext} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import IconSantander from '@adv-mt/mt-svg-icons/lib/Scf.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

const getModalChildren = ({i18n}) => {
  return (
    <div className="mt-TransactionWithdrawalReasonsModal-modalChildren">
      <div className="mt-TransactionWithdrawalReasonsModal-description">
        {i18n.t('VEHICLE_TRANSACTION.WITHDRAWAL_REASONS_MODAL.TEXT_PARAGRAPH_1')}
      </div>
      <div className="mt-TransactionWithdrawalReasonsModal-description">
        {htmlStringToReactElement(
          i18n.t('VEHICLE_TRANSACTION.WITHDRAWAL_REASONS_MODAL.TEXT_PARAGRAPH_2', {
            highlightStart: '<strong>',
            highlightEnd: '</strong>'
          })
        )}
      </div>
      <div className="mt-TransactionWithdrawalReasonsModal-contentWrapper mt-TransactionWithdrawalReasonsModal-contentWrapper--withIcon">
        <div className="mt-TransactionWithdrawalReasonsModal-contentIcon">
          <IconSantander size={ATOM_ICON_SIZES.medium} />
        </div>
        <div className="mt-TransactionWithdrawalReasonsModal-contentText">
          <div className="mt-TransactionWithdrawalReasonsModal-contentTextTitle">
            {i18n.t('VEHICLE_TRANSACTION.WITHDRAWAL_REASONS_MODAL.TEXT_BOX_TITLE')}
          </div>
          <span>{i18n.t('VEHICLE_TRANSACTION.WITHDRAWAL_REASONS_MODAL.TEXT_BOX')}</span>
        </div>
      </div>
    </div>
  )
}

export const WithdrawalReasonsTransactionModal = () => {
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')

  const imageUrl = `${urlStaticsImages}illustrations/buyer-verify-account.svg`

  return (
    <MoleculeModal
      isOpen={true}
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionWithdrawalReasonsModal-modalContainer">
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: getModalChildren({i18n}),
              headerImage: (
                <div className="mt-TransactionModal-contentHeaderImageWrapper">
                  <AtomImage
                    alt={i18n.t('VEHICLE_TRANSACTION.WITHDRAWAL_REASONS_MODAL.TITLE')}
                    className="mt-TransactionModal-contentHeaderImage"
                    src={imageUrl}
                  />
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.WITHDRAWAL_REASONS_MODAL.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
